export const GET_ORGANISATION = 'app/ManageUsers/GET_ORGANISATION'
export const GET_ORGANISATION_DONE = 'app/ManageUsers/GET_ORGANISATION_DONE'
export const GET_ORGANISATION_ERROR = 'app/ManageUsers/GET_ORGANISATION_ERROR'

export const GET_USERS_PAGE = 'app/ManageUsers/GET_USERS_PAGE'
export const GET_USERS_PAGE_DONE = 'app/ManageUsers/GET_USERS_PAGE_DONE'
export const CLEAR_USERS = 'app/ManageUsers/CLEAR_USERS'
export const GET_USERS_PAGE_ERROR = 'app/ManageUsers/GET_USERS_PAGE_ERROR'

export const GET_USER_BY_ID = 'app/ManageUsers/GET_USER_BY_ID'
export const GET_USER_BY_ID_DONE = 'app/ManageUsers/GET_USER_BY_ID_DONE'
export const CLEAR_USER = 'app/ManageUsers/CLEAR_USER'
export const GET_USER_BY_ID_ERROR = 'app/ManageUsers/GET_USER_BY_ID_ERROR'

export const UPDATE_USER = 'app/ManageUsers/UPDATE_USER'
export const UPDATE_USER_DONE = 'app/ManageUsers/UPDATE_USER_DONE'
export const UPDATE_USER_ERROR = 'app/ManageUsers/UPDATE_USER_ERROR'

export const SAVE_NEW_USER_AVATAR = 'app/ManageUsers/SAVE_NEW_USER_AVATAR'
export const SAVE_NEW_USER_AVATAR_DONE =
  'app/ManageUsers/SAVE_NEW_USER_AVATAR_DONE'
export const SAVE_NEW_USER_AVATAR_ERROR =
  'app/ManageUsers/SAVE_NEW_USER_AVATAR_ERROR'

export const BULK_UPDATE_USERS = 'app/ManageUsers/BULK_UPDATE_USERS'
export const BULK_UPDATE_USERS_DONE = 'app/ManageUsers/BULK_UPDATE_USERS_DONE'
export const BULK_UPDATE_USERS_ERROR = 'app/ManageUsers/BULK_UPDATE_USERS_ERROR'

export const INVITE_USER = 'app/ManageUsers/INVITE_USER'
export const INVITE_USER_ERROR = 'app/ManageUsers/INVITE_USER_ERROR'

export const CLEAR_IMPORT_USERS = 'app/ManageUsers/CLEAR_IMPORT_USERS'
export const UPLOAD_USERS_FILE = 'app/ManageUsers/UPLOAD_USERS_FILE'
export const UPLOAD_USERS_FILE_DONE = 'app/ManageUsers/UPLOAD_USERS_FILE_DONE'
export const UPLOAD_USERS_FILE_ERROR = 'app/ManageUsers/UPLOAD_USERS_FILE_ERROR'
export const IMPORT_USERS = 'app/ManageUsers/IMPORT_USERS'
export const IMPORT_USERS_ERROR = 'app/ManageUsers/IMPORT_USERS_ERROR'

export const CLEAR_USER_PROJECT_MATRIX =
  'app/ManageUsers/CLEAR_USER_PROJECT_MATRIX'
export const GET_USER_PROJECT_MATRIX = 'app/ManageUsers/GET_USER_PROJECT_MATRIX'
export const GET_USER_PROJECT_MATRIX_DONE =
  'app/ManageUsers/GET_USER_PROJECT_MATRIX_DONE'
export const GET_USER_PROJECT_MATRIX_ERROR =
  'app/ManageUsers/GET_USER_PROJECT_MATRIX_ERROR'

export const UPDATE_USERS_MEMBERSHIPS =
  'app/ManageUsers/UPDATE_USERS_MEMBERSHIPS'
export const UPDATE_USERS_MEMBERSHIPS_ERROR =
  'app/ManageUsers/UPDATE_USERS_MEMBERSHIPS_ERROR'

export const CLEAR_RESEND_INVITATION = 'app/ManageUsers/CLEAR_RESEND_INVITATION'
export const RESEND_INVITATION = 'app/ManageUsers/RESEND_INVITATION'
export const RESEND_INVITATION_DONE = 'app/ManageUsers/RESEND_INVITATION_DONE'
export const RESEND_INVITATION_ERROR = 'app/ManageUsers/RESEND_INVITATION_ERROR'

export const GET_COMPANY_NAMES = 'app/ManageUsers/GET_COMPANY_NAMES'
export const GET_COMPANY_NAMES_DONE = 'app/ManageUsers/GET_COMPANY_NAMES_DONE'
export const GET_COMPANY_NAMES_ERROR = 'app/ManageUsers/GET_COMPANY_NAMES_ERROR'

export const ADD_COMPANY_NAME = 'app/ManageUsers/ADD_COMPANY_NAME'
export const ADD_COMPANY_NAME_DONE = 'app/ManageUsers/ADD_COMPANY_NAME_DONE'
export const ADD_COMPANY_NAME_ERROR = 'app/ManageUsers/ADD_COMPANY_NAME_ERROR'

export const DELETE_COMPANY_NAME = 'app/ManageUsers/DELETE_COMPANY_NAME'
export const DELETE_COMPANY_NAME_DONE =
  'app/ManageUsers/DELETE_COMPANY_NAME_DONE'
export const DELETE_COMPANY_NAME_ERROR =
  'app/ManageUsers/DELETE_COMPANY_NAME_ERROR'

export const CHANGE_COMPANY_NAME = 'app/ManageUsers/CHANGE_COMPANY_NAME'
export const CHANGE_COMPANY_NAME_DONE =
  'app/ManageUsers/CHANGE_COMPANY_NAME_DONE'
export const CHANGE_COMPANY_NAME_ERROR =
  'app/ManageUsers/CHANGE_COMPANY_NAME_ERROR'

export const GET_USERS_ROOT_FOLDER = 'app/ManageUsers/GET_USERS_ROOT_FOLDER'
export const GET_USERS_ROOT_FOLDER_DONE =
  'app/ManageUsers/GET_USERS_ROOT_FOLDER_DONE'
export const GET_USERS_ROOT_FOLDER_ERROR =
  'app/ManageUsers/GET_USERS_ROOT_FOLDER_ERROR'

export const SET_USERS_ROOT_FOLDER = 'app/ManageUsers/SET_USERS_ROOT_FOLDER'
export const SET_USERS_ROOT_FOLDER_DONE =
  'app/ManageUsers/SET_USERS_ROOT_FOLDER_DONE'
export const SET_USERS_ROOT_FOLDER_ERROR =
  'app/ManageUsers/SET_USERS_ROOT_FOLDER_ERROR'

export const ASSIGN_LICENSE_TO_USER = 'app/ManageUsers/ASSIGN_LICENSE_TO_USER'
export const ASSIGN_LICENSE_TO_USER_DONE =
  'app/ManageUsers/ASSIGN_LICENSE_TO_USER_DONE'
export const ASSIGN_LICENSE_TO_USER_ERROR =
  'app/ManageUsers/ASSIGN_LICENSE_TO_USER_ERROR'

export const REMOVE_LICENSE_FROM_USER =
  'app/ManageUsers/REMOVE_LICENSE_FROM_USER'
export const REMOVE_LICENSE_FROM_USER_DONE =
  'app/ManageUsers/REMOVE_LICENSE_FROM_USER_DONE'
export const REMOVE_LICENSE_FROM_USER_ERROR =
  'app/ManageUsers/REMOVE_LICENSE_FROM_USER_ERROR'

export const validationErrors = {
  REQUIRED: 'required',
  TOO_LONG: 'tooLong',
  NO_EMAIL: 'noEmail',
}

export const importFieldAttributes = [
  'FirstName',
  'LastName',
  'Name',
  'Phone',
  'Fax',
  'JobTitle',
  'InternalId',
  'Email',
  'Username',
  'Street',
  'Zip',
  'City',
  'Active',
  'Ignore',
  'CompanyName',
]
